import PropTypes from "prop-types";
import * as React from "react";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";

export function sortHelper(a, b) {
  if (b < a) {
    return -1;
  }
  if (b > a) {
    return 1;
  }
  return 0;
}
export function descendingComparator(a, b, orderBy) {
  if (orderBy === "branch-location") {
    return sortHelper(
      a["addressDto"].addressLine1,
      b["addressDto"].addressLine1
    );
  } else {
    return sortHelper(a[orderBy], b[orderBy]);
  }
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function EnhancedTableHead(props) {
  const createSortHandler = (property) => (event) => {
    props.onRequestSort(event, property);
  };

  return (
    <TableHead className="table-head">
      <TableRow style={{ backgroundColor: props.backColor }}>
        {props.headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={props.orderBy === headCell.id ? props.order : false}
          >
            {headCell.disableSorting !== undefined && headCell.disableSorting ? (
              // Render the label without sorting functionality
              <Box
                component="div"
                style={{ fontWeight: "bold", color: props.textColor }}
              >
                {headCell.label}
              </Box>
            ) : (
              // Render the label with sorting functionality
              <TableSortLabel
                active={true}
                direction={props.orderBy === headCell.id ? props.order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{ fontWeight: "bold", color: props.textColor }}
              >
                {headCell.label}
                {props.orderBy === headCell.id ? (
                  <Box component="span" sx={{ ...visuallyHidden }}>
                    {props.order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
};
